import React from 'react';
import checkbox from "../images/check_box-24px 1.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronRight, faGlobe } from '@fortawesome/free-solid-svg-icons'


class Welcome extends React.Component  {
    constructor(props) {
        super(props);
        this.handleLanguageChange   = this.handleLanguageChange.bind(this);
    }
        
    handleLanguageChange = (e) =>{
        const selected = e.target.value;
        const url = selected === "au" ? "/" : "/"+selected;
        window.location.href = url;
    }


    

    render() {
        const {language, handleChange, showModal, showError, handleNext, handleClick, hotelCode, hotelName, hotelSearchResults, hotelSearch, translateLanguage, region} = this.props;
        console.log('region', region)
        return (
            <div className="hotelSales-hotelDetails container">
                <div class="row mt-3">
                    <div class="col-md-10 col-sm-9"></div>
                    <div class="col-12 col-md-2 col-sm-3">
                        <div className="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><FontAwesomeIcon icon={faGlobe} /></span>
                                </div>
                                <select className="form-control" onChange={this.handleLanguageChange}>
                                {translateLanguage.map((key) => <option value={key[0]} selected={region === key[0] ? true: false}>{key[1]}</option>)}
                                </select> 
                            </div>
                        </div>
                    </div>
                </div>  
            {/* <div className="hotelSales-welcomeMsg mt-3">
                {
                    region === 'vn' ? (
                        <div>
                            <p className='text-bold'>Heartists® ơi, hãy cùng tìm hiểu lý do chính tạo nên chương trình kỷ niệm này nhé!                </p>
                            <p>Trong <span className='text-bold'>30 năm qua</span>, Accor Plus đã xây dựng tiêu chuẩn về lòng trung thành, tất cả là nhờ vào Heartists®.</p>
                            <p>Năm nay, chúng tôi sẽ tổ chức chương trình LỚN: cơ hội nhận thêm <span className='text-bold'>VND 300,000 tiền thưởng</span> cho mỗi gói <span className='text-bold'>hội viên Explorer </span>bán được trong vòng <span className='text-bold'>30 ngày.</span></p>                          
                            <p>Chúng tôi sẽ dành ra <span className='text-bold'>30 ngày, từ ngày 18/11 đến ngày 18/12</span> để kỷ niệm, ghi nhận và tưởng thưởng cho tinh thần làm việc tận tâm mà bạn mang đến. Hãy sẵn sàng cho chương trình vui chơi có thưởng kéo dài <span className='text-bold'>30 ngày.</span></p>
                            <p>Hãy tham gia <span className='text-bold'>chương trình kỷ niệm này!</span></p>
                            <h4>{language.welcome}</h4>
                            <p>{language.beforeWeGetStarted}</p>
                            <p>{language.toAssist}</p>
                        </div>                        
                    ) : region === 'id' ? (
                        <div>
                            <p className='text-bold'>Heartists®, temukan alasan terbesar Anda untuk merayakan!</p>
                            <p>Selama <span className='text-bold'>30 tahun</span>, Accor Plus telah menetapkan standar loyalitas, terima kasih kepada Anda - Heartists® kami.</p>
                            <p>Tahun ini, kami akan melakukan hal BESAR: <span className='text-bold'>30 hari</span> untuk mendapatkan <span className='text-bold'>insentif tambahan 30%</span> untuk setiap <span className='text-bold'>keanggotaan Explorer</span> yang Anda jual.</p>                          
                            <p><span className='text-bold'>18 November hingga 18 Desember</span> adalah <span className='text-bold'>30 hari</span> perayaan, pengakuan, dan penghargaan atas hati dan jiwa yang telah Anda berikan. Bersiaplah untuk mengubah 30 menjadi hujan bonus sebulan penuh.</p>
                            
                            <p>Bergabunglah di <span className='text-bold'>perayaan ini!</span></p>
                            <h4>{language.welcome}</h4>
                            <p>{language.beforeWeGetStarted}</p>
                            <p>{language.toAssist}</p>
                        </div>
                    ) : region === 'th' ? (
                        <div>
                            <p className='text-bold'>สำหรับชาว Heartists® โอกาสสำคัญในการเฉลิมฉลองมาถึงแล้ว!</p>
                            <p>ตลอด <span className='text-bold'>30 ปีที่ผ่านมา</span>, Accor Plus ได้สร้างมาตรฐานอันดีให้กับระบบโปรแกรมสมาชิก ซึ่งต้องขอขอบคุณชาว Heartists® ทุกคน</p>
                            <p>ปีนี้ พิเศษยิ่งขึ้น: ภายในเวลา  <span className='text-bold'>30 วัน</span> ต่อจากนี้ <span className='text-bold'>รับค่าอินเซ็นทีฟพิเศษเพิ่มอีก 30%</span> สำหรับทุกๆ การขาย <span className='text-bold'>สมาชิกประเภท Explorer</span> ได้สำเร็จ</p>                         
                            <p><span className='text-bold'>ตั้งแต่วันที่ 18 พฤศจิกายน ถึง 18 ธันวาคม</span> จะเป็น <span className='text-bold'>30 วัน </span> แห่งการเฉลิมฉลอง เชิดชูเกียรติ และตอบแทนทุกความทุ่มเททั้งแรงกายและแรงใจ เตรียมตัวให้พร้อม แล้วมาฉลอง 30 ปี ด้วยโบนัสต่อเนื่องตลอดทั้งเดือน!</p>
                            <p>เตรียมตัวให้พร้อม <span className='text-bold'>เฉลิมฉลองไปด้วยกัน!</span></p>
                            <h4>{language.welcome}</h4>
                            <p>{language.beforeWeGetStarted}</p>
                            <p>{language.toAssist}</p>
                        </div>
                    ) : (
                        <div>
                            <p className='text-bold'>Heartists®, meet your next big reason to celebrate!</p>
                            <p>For <span className='text-bold'>30 years</span>, Accor Plus has set the standard in loyalty, thanks to you - our Heartists®.</p>
                            <p>This year, we're going BIG: <span className='text-bold'>30 days</span> of earning <span className='text-bold'>{language.incentive}</span> <span className='text-bold'>extra incentive</span> for every <span className='text-bold'>Explorer membership</span> you sell.</p>
                            <p>From <span className='text-bold'>18 November to 18 December</span> it's <span className='text-bold'>30 days</span> of celebration, recognition, and rewards for the heart and soul you bring. Get ready to turn 30 into a month-long bonus spree.</p>
                            <p>Get in on the <span className='text-bold'>celebration!</span></p>
                            <h4>{language.welcome}</h4>
                            <p>{language.beforeWeGetStarted}</p>
                            <p>{language.toAssist}</p>
                        </div>
                    )
                }
                    <h4>{language.welcome}</h4>
                        <p>{language.beforeWeGetStarted}</p>
                    <p>{language.toAssist}</p>
                <div>
                    <h4>{language.supplliedDetails}</h4>
                    <p>{language.employeeType}: {language.hotelHeartist}</p>
                </div>
            </div> */}

            <div class="banner-warning alert alert-danger d-flex" role="alert">
                <div className='holder-warning-icon'>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                        </svg>                        
                    </span>
                </div>
                <div className='holder-warning-content'>
                    <div><strong className='content-white'>{language.warning}</strong></div>
                    {language.errorOctoberRelease}
                </div>           
            </div>
                
            {/* <div className="hotelSales-welcomeMsg mt-3">
                <div>
                    <h4>{language.welcome}</h4>
                    <p>{language.beforeWeGetStarted}</p>
                    <p>{language.toAssist}</p>
                </div>
                <div>
                    <h4>{language.supplliedDetails}</h4>
                    <p>{language.employeeType}: {language.hotelHeartist}</p>
                </div>
            </div> */}
    
            <h4>{language.hotelDetails} <sup>*</sup></h4>
            <p>{language.pleaseProvide}</p>

            <div className="hotel-code-container row">
                <div className="form-group col-12 col-md-6">
                    <label className="ridCode">{language.hotelRIDCode} <sup>*</sup></label>
                    <input type="text" placeholder="Enter RID Code" className={`form-control ${showError && !hotelCode ? ' border border-danger' : ''}`} required value={hotelCode && hotelCode.toUpperCase()} onChange={handleChange}/>
                    {showError && !hotelCode && (
                        <div className="error">{language.enterRIDCode} <a onClick={showModal} href="#">{language.clickHere}</a>.</div>
                    )}
                    <button className="btn btn-secondary mt-4" onClick={handleClick}>{language.check} <FontAwesomeIcon icon={faCheck} /></button>
                </div> 

                {hotelSearch && !hotelSearchResults && (
                    <div className="hotel-results-container col-12 col-md-6">
                        <h5>{language.result}</h5>
                        <div className="mt-3">
                            No results. <a onClick={showModal} href="#">{language.clickHere}.</a>
                        </div>
                        </div>
                )}
                
                {hotelSearch && hotelSearchResults && hotelName && hotelCode && (
                    <div className="hotel-results-container col-12 col-md-6">
                        <h5>{language.result}</h5>
                        <div className="mt-3">
                            <img src={checkbox} width="25"/> {hotelName} -RID {hotelCode}
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-2">
                <p>{language.dontKnowHotelCode} <a onClick={showModal} href="#">{language.clickHere}</a></p>
            </div>

            {/* <div className="d-flex justify-content-between">
                <p className="disclaimer">*{language.mandatoryQuestion}</p>
                <button 
                    className="btn btn-primary"
                    onClick={handleNext}>{language.next} <FontAwesomeIcon icon={faChevronRight} /></button>
            </div> */}
        </div>
        );
    }
}

export default (Welcome);